import { render, staticRenderFns } from "./columnsAside.vue?vue&type=template&id=689455a9&scoped=true"
import script from "./columnsAside.vue?vue&type=script&lang=js"
export * from "./columnsAside.vue?vue&type=script&lang=js"
import style0 from "./columnsAside.vue?vue&type=style&index=0&id=689455a9&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689455a9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('689455a9')) {
      api.createRecord('689455a9', component.options)
    } else {
      api.reload('689455a9', component.options)
    }
    module.hot.accept("./columnsAside.vue?vue&type=template&id=689455a9&scoped=true", function () {
      api.rerender('689455a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/component/columnsAside.vue"
export default component.exports